import React from 'react';
import { Card, Stencil, Row, Col, Spacer } from '@cleartrip/bento';

function StatusLoading() {
	return (
		<>
			<Card className='bc-neutral-100 ba bw-1 px-4 py-5 br-4'>
				<Row className='flex-middle'>
					<Col>
						<Stencil shimmer width='50%' height={16} />
						<Spacer mt={4} />
						<Stencil shimmer width='60%' height={30} />
						<Spacer mt={2} />
						<Stencil shimmer width='90%' height={16} />
					</Col>
					<Col>
						<Spacer mt={8} />
						<Stencil shimmer width='60%' height={30} />
						<Spacer mt={2} />
						<Stencil shimmer width='90%' height={16} />
					</Col>
					<Col>
					<Spacer mt={8} />
						<Stencil shimmer width='60%' height={30} />
						<Spacer mt={2} />
						<Stencil shimmer width='90%' height={16} />
					</Col>
					<Col>
					<Spacer mt={8} />
						<Stencil shimmer width='60%' height={30} />
						<Spacer mt={2} />
						<Stencil shimmer width='90%' height={16} />
					</Col>
					<Col>
						<Spacer mt={8} />
						<Stencil shimmer width='60%' height={30} />
						<Spacer mt={2} />
						<Stencil shimmer width='90%' height={16} />
					</Col>
				</Row>
			</Card>
		</>
	);
}

export default StatusLoading;
